export default __webpack_public_path__ + "static/media/inlandBlueHole1.dc33b508.webp";